import React from 'react';
import { Box, makeStyles, Theme, AppBar, Tabs, Tab } from '@material-ui/core';
import colors from '../../../../themes/main-colors';
import { useTranslation } from '../../../../hooks/useTranslation';

const useStyles = makeStyles((theme: Theme) => ({
  tabs: {
    display: 'flex',
    textAlign: 'center',
  },
  tabsRoot: {
    width: '100%',
  },
  appBar: {
    backgroundColor: colors.lightGray2,
    color: colors.sparkBlue,
    '& .MuiTab-root': {
      fontSize: '1rem',
      fontWeight: 600,
    },
    '& .MuiTab-textColorInherit.Mui-selected': {
      fontWeight: 600,
      backgroundColor: colors.white,
      color: colors.black,
    },
  },
}));

interface TabPanelProps {
  children?: React.ReactNode;
  index: any;
  value: any;
}

interface TabsProps {
  myAccountPanel?: React.ReactNode;
  anotherLocationPanel?: React.ReactNode;
  tabNumber?: number;
  setTabNumber?: (num: number) => void;
  hideTabs?: boolean;
}

function TabPanel(props: TabPanelProps) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`full-width-tabpanel-${index}`}
      aria-labelledby={`full-width-tab-${index}`}
      {...other}
    >
      {value === index && <Box>{children}</Box>}
    </div>
  );
}

function a11yProps(index: any) {
  return {
    id: `full-width-tab-${index}`,
    'aria-controls': `full-width-tabpanel-${index}`,
  };
}

export const OutageTabs = ({
  myAccountPanel,
  anotherLocationPanel,
  tabNumber,
  setTabNumber,
  hideTabs,
}: TabsProps) => {
  const classes = useStyles();
  const { t } = useTranslation();
  const handleChange = (event: React.ChangeEvent<{}>, newValue: number) => {
    setTabNumber && setTabNumber(newValue);
  };
  return (
    <div className={classes.tabsRoot}>
      {!hideTabs && (
        <AppBar position="static" className={classes.appBar} elevation={0}>
          <Tabs
            value={typeof tabNumber === 'number' ? tabNumber : 0}
            onChange={handleChange}
            indicatorColor="primary"
            variant="fullWidth"
            aria-label="full width tabs example"
          >
            <Tab label={t('MY_ACCOUNT')} {...a11yProps(0)} />
            <Tab label={t('ANOTHER_LOCATION')} {...a11yProps(1)} />
          </Tabs>
        </AppBar>
      )}
      <TabPanel value={tabNumber} index={0}>
        {myAccountPanel}
      </TabPanel>
      <TabPanel value={tabNumber} index={1}>
        {anotherLocationPanel}
      </TabPanel>
    </div>
  );
};
